/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetScriptModel } from '../models';
/**
 * CustomOutputApi - axios parameter creator
 * @export
 */
export const CustomOutputApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Custom Output
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomOutput: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/customOutput`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [description] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCustomParser: async (name?: string, description?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/customOutput`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomOutputApi - functional programming interface
 * @export
 */
export const CustomOutputApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomOutputApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Custom Output
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomOutput(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetScriptModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomOutput(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomOutputApi.getCustomOutput']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [description] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCustomParser(name?: string, description?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCustomParser(name, description, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomOutputApi.patchCustomParser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomOutputApi - factory interface
 * @export
 */
export const CustomOutputApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomOutputApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Custom Output
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomOutput(options?: RawAxiosRequestConfig): AxiosPromise<GetScriptModel> {
            return localVarFp.getCustomOutput(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomOutputApiPatchCustomParserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCustomParser(requestParameters: CustomOutputApiPatchCustomParserRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchCustomParser(requestParameters.name, requestParameters.description, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomOutputApi - interface
 * @export
 * @interface CustomOutputApi
 */
export interface CustomOutputApiInterface {
    /**
     * 
     * @summary Get Custom Output
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomOutputApiInterface
     */
    getCustomOutput(options?: RawAxiosRequestConfig): AxiosPromise<GetScriptModel>;

    /**
     * 
     * @param {CustomOutputApiPatchCustomParserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomOutputApiInterface
     */
    patchCustomParser(requestParameters?: CustomOutputApiPatchCustomParserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for patchCustomParser operation in CustomOutputApi.
 * @export
 * @interface CustomOutputApiPatchCustomParserRequest
 */
export interface CustomOutputApiPatchCustomParserRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomOutputApiPatchCustomParser
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof CustomOutputApiPatchCustomParser
     */
    readonly description?: string

    /**
     * 
     * @type {File}
     * @memberof CustomOutputApiPatchCustomParser
     */
    readonly file?: File
}

/**
 * CustomOutputApi - object-oriented interface
 * @export
 * @class CustomOutputApi
 * @extends {BaseAPI}
 */
export class CustomOutputApi extends BaseAPI implements CustomOutputApiInterface {
    /**
     * 
     * @summary Get Custom Output
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomOutputApi
     */
    public getCustomOutput(options?: RawAxiosRequestConfig) {
        return CustomOutputApiFp(this.configuration).getCustomOutput(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomOutputApiPatchCustomParserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomOutputApi
     */
    public patchCustomParser(requestParameters: CustomOutputApiPatchCustomParserRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomOutputApiFp(this.configuration).patchCustomParser(requestParameters.name, requestParameters.description, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}

